import moment from 'moment';
import "moment/locale/pt-br";

export default {
    name: "filtros",
    filters: {
        formatDate: function (value) {
            if (value) {
                return moment(String(value)).format('DD/MM/YYYY')
            }
        },
        formatCpfCnpj: function (value) {
            if (value) {
                value = value.trim();

                if (value.length === 11)
                    return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
                else if (value.length === 14)
                        return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "$1.$2.$3/$4-$5");
                    else return value;
            }
        },
        dataFormatada: function (value) {
            if (!value) return ''
            return moment(value).format("DD/MM/YYYY")
        },

        dataHoraFormatada: function (value) {
            if (!value) return ''
            return moment(value).format("DD/MM/YYYY") +" às " + moment(value).format("HH:mm:ss")
        },
        formatarMoeda: function (value) {
            if (!value) return 'R$ 0,00';

            return Number(value) ? ("R$ ") + Number(value).toLocaleString("pt-BR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }) : "";
        },
        truncateString:function (value,_tamanho) {
            if (!value) return "";
            var tamanho = _tamanho ? _tamanho : 50
            if(value.length>tamanho){
                value = value.substring(0, tamanho) + "..." +value.substring(value.length -3, value.length);
            }
            return value;
        },
        formatPercentage: function(value){
            if (!value) return "";
            
            return Number(value) ? Number(value).toLocaleString("pt-BR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }) + ("%") : "";
        }
    }
}
